import { Injectable } from '@angular/core';
import { ShiftValidationDetails } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable()
export abstract class ValidationDataSourceService {
  abstract hasShiftValidated(shiftId: string): Observable<boolean>;
  abstract isShiftOfUserValidated(
    userId: string,
    shiftStartDate: Date,
  ): Observable<boolean>;
  abstract isCurrentUserValidationLoading(userId: string): Observable<boolean>;
  abstract isShiftValidationLoadingForAssignedShifts(
    shiftId: string,
  ): Observable<boolean>;
  abstract isShiftValidationLoadingForUnassignedShifts(
    shiftId: string,
  ): Observable<boolean>;
  abstract shiftValidationStreamForAssignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[] | undefined>;
  abstract shiftValidationStreamForUnassignedShifts(
    shiftId: string,
  ): Observable<ShiftValidationDetails[] | undefined>;
  abstract isLoadingValidationsError(): Observable<boolean>;
  abstract isLoadingValidationsV1Error(): Observable<boolean>;
}
